import { useUiVersion } from 'hooks';
import { SimpleSelect } from 'libs/ui';

import { CustomSelect } from '../inputs/CustomSelect';

export const Select2 = (props) => {
  const { items, value, onChange, width, ...rest } = props;
  const { isNew } = useUiVersion();

  const itemsEl = items.map((el, idx) => {
    return (
      <option key={idx} value={el.value}>
        {el.name}
      </option>
    );
  });

  // v2: render the same custom dropdown used across the redesign (green
  // selection) instead of a native <select>; adapt onChange to the native shape.
  if (isNew) {
    const input = { value, onChange: (v) => onChange && onChange({ target: { value: v } }) };
    return (
      <CustomSelect input={input} width={width}>
        {itemsEl}
      </CustomSelect>
    );
  }

  return (
    <SimpleSelect value={value} onChange={onChange} {...rest}>
      {itemsEl}
    </SimpleSelect>
  );
};
